import { useLazyQuery } from '@apollo/client';
import { TBaseCommentProps } from '../CommentsList';
import getSortedCommentsForArticle from '../queries/getSortedCommentsForArticle';

export const useGetSortedCommentsQuery = ({
  articleId,
  userId,
  parentCommentId,
}: {
  articleId: string;
  userId?: string;
  parentCommentId?: string;
}) =>
  useLazyQuery<
    { sortedCommentsForArticle?: TBaseCommentProps[] },
    { articleId?: string; userId?: string; parentCommentId?: string }
  >(getSortedCommentsForArticle, {
    variables: { articleId, userId, parentCommentId },
    fetchPolicy: 'cache-and-network',
  });
